var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.value ? 'flip-container flipped' : 'flip-container'},[_c('div',{staticClass:"flipper"},[_c('div',{staticClass:"front"},[_vm._t("front")],2),_c('div',{staticClass:"back"},[_vm._t("back")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }